import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetRefrigerationUnitModelsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetRefrigerationUnitModelsQuery = {
  __typename?: 'query_root';
  container_insights_refrigeration_unit_models: Array<{
    __typename?: 'container_insights_refrigeration_unit_models';
    id: any;
    name: string;
    label: string;
    manufacturer: {
      __typename?: 'container_insights_manufacturers';
      id: any;
      name: string;
      label: string;
    };
  }>;
};

export const GetRefrigerationUnitModelsDocument = gql`
  query GetRefrigerationUnitModels {
    container_insights_refrigeration_unit_models {
      id
      name
      label
      manufacturer {
        id
        name
        label
      }
    }
  }
`;

export function useGetRefrigerationUnitModelsQuery(
  options?: Omit<
    Urql.UseQueryArgs<GetRefrigerationUnitModelsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    GetRefrigerationUnitModelsQuery,
    GetRefrigerationUnitModelsQueryVariables
  >({ query: GetRefrigerationUnitModelsDocument, ...options });
}
